import React, {useContext, useState} from "react";
import { Card, Button, Modal } from "react-bootstrap";
import {deleteUserAccount} from "../../http/userAPI";
import {toast} from "react-toastify";
import {MAIN_ROUTE} from "../../utils/consts";
import {Context} from "../../index";

const DeleteAccount = () => {
    const [showConfirm, setShowConfirm] = useState(false);
    const { user } = useContext(Context);
    const id = user.user.id;

    const logOut = () => {
        localStorage.removeItem('token');
        user.setUser({});
        user.setIsAuth(false);
        user.setActiveComponent("")
        window.location.assign(MAIN_ROUTE);
    };

    const openConfirm = () => setShowConfirm(true);
    const closeConfirm = () => setShowConfirm(false);

    const handleDeleteAccount = async () => {
        try {
            const response = await deleteUserAccount({id});
            toast.success(response.message || "Account deleted successfully.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            closeConfirm();
            logOut();
        } catch (e) {
            toast.error(
                e.response?.data?.message || "Failed to delete account.",
                { position: "bottom-center", autoClose: 3000, hideProgressBar: false }
            );
        }
    };

    return (
        <Card className="p-3 w-100 mt-0">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
                <h5 className="text-muted mb-2 mb-md-0">Delete Account</h5>
            </div>

            <small className="text-muted d-block mt-2">
                Deleting your Virtalibry account is a serious and irreversible step.
                Once confirmed, <strong>all associated data</strong> will be removed from our systems,
                including:
                <ul className="mt-2 mb-2">
                    <li>profile and authentication data;</li>
                    <li>books, manuscripts, titles, covers and attachments;</li>
                    <li>assignments, logs, balances, payouts, bonuses;</li>
                    <li>saved settings and preferences.</li>
                </ul>
                <div className="mt-1">
                    <strong className="text-danger">Warning:</strong> Once deleted, your
                    data cannot be restored.
                </div>

                {user?.user?.tariff_plan !== "FREE" && (
                    <div className="mt-2 fw-bold text-danger">
                        Important: Deleting your account does <u>not</u> cancel recurring
                        subscription payments with our payment provider. If you intend to
                        stop billing, please cancel your subscription first via the
                        Customer Portal in the top menu before deleting your account.
                    </div>
                )}

                <div className="mt-3">
                    At Virtalibry, we value every member and sincerely regret when someone
                    decides to leave. Your participation and feedback have been vital to our
                    growth. At the same time, we are committed to protecting your privacy.
                    Laws such as the <strong>California Consumer Privacy Act (CCPA)</strong> in the United States and the <strong>General Data Protection Regulation (GDPR)</strong> in the European Union guarantee your right to permanently delete your
                    data. We comply with these frameworks because it is not only a legal
                    requirement but also a matter of principle.
                </div>

                <div className="mt-2">
                    By confirming deletion, you are exercising your right to be forgotten.
                    This action will erase your account and all related data beyond
                    recovery. Please consider carefully and, if in doubt, reach out to
                    support. If you proceed, your request will be handled promptly and in
                    full compliance with privacy laws.
                </div>
            </small>

            <div className="d-flex justify-content-end mt-3">
                <Button
                    variant="danger"
                    size="sm"
                    onClick={openConfirm}
                    title="Permanently delete your account"
                >
                    Delete Account
                </Button>
            </div>

            {/* Confirm modal */}
            <Modal show={showConfirm} onHide={closeConfirm} top>
                <Modal.Header closeButton style={{ height: 40 }}>
                    <Modal.Title className="fs-6">Confirm Deletion</Modal.Title>
                </Modal.Header>

                <Modal.Body className="small">
                    <p className="mb-2 fs-6 fw-semibold text-muted text-danger text-center">
                        Are you sure you want to delete your account?
                    </p>
                    <p className="mb-0 text-muted">
                        This will permanently remove your profile, books, manuscripts,
                        assignments, balances, and all related records. This action cannot
                        be undone.
                    </p>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between" style={{ height: 60 }}>
                    <Button variant="outline-secondary" size="sm" onClick={closeConfirm}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={handleDeleteAccount}
                    >
                        Delete Account
                    </Button>
                </Modal.Footer>
            </Modal>
        </Card>
    );
};

export default DeleteAccount;
